import React from "react";
import styles from "./index.module.scss";
import AddIcon from "../../Assets/images/add.svg";
import BannerForm from "./BannerForm";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
export default function Banner(props) {
  const bannersData = props.bannersData ? props.bannersData : [];
  const [open, setOpen] = React.useState(true);

  const handleAddBanner = async () => {
    if (props.addNewBanner) {
      await props.addNewBanner();
      await handleScrollFunction();
    }
  };
  const handleRemoveBanner = (event, remove_banner_id) => {
    event.stopPropagation();
    props.removeBanner(remove_banner_id);
  };

  const handleScrollFunction = async () => {
    if (bannersData.length > 0) {
      const titleElement = await document.getElementById(
        "home_banner_" + (bannersData.length + 1)
      );
      if (titleElement) {
        titleElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <div className={`mb-4`} id={`banner-section`}>
      <Accordion style={{ boxShadow: "none" }} expanded={open}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon onClick={() => setOpen(!open)} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{cursor: props.isDisableFields && "default"}}
        >
          <AccordionDetails>
            <Typography>
              <div className={styles.title}>Banner</div>
              {props.setPageForView === 1 || props.isDisableFields ? (
                ""
              ) : (
                <a
                  href="/"
                  className={`link cursor-pointer ml-2 mt-1 ${styles.searchIconWrapper}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleAddBanner();
                  }}
                >
                  <img className={styles.searchIcon} src={AddIcon} alt="Add" />
                </a>
              )}
            </Typography>
          </AccordionDetails>
        </AccordionSummary>

        <Typography>
          {bannersData &&
            bannersData?.map((banner, index) => {
              let bannerCount = index + 1;
              return (
                <div
                  className={`md-2 ${styles.banners}`}
                  id={`home_banner_${bannerCount}`}
                  key={index}
                >
                  <div className={styles.circle}>{bannerCount}</div>
                  <div style={{ width: "100%" }}>
                    <BannerForm
                      bannerModule={
                        props.bannerModule ? props.bannerModule : ""
                      }
                      bannerData={banner}
                      removeBanner={handleRemoveBanner}
                      index={index}
                      setBannerData={props.setBannerData}
                      checkBannerData={props.checkBannerData}
                      uploadImageType={
                        props.uploadImageType ? props.uploadImageType : ""
                      }
                      isDisableFields={props.isDisableFields}
                    />
                  </div>
                </div>
              );
            })}
        </Typography>
      </Accordion>
    </div>
  );
}
